import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/list-master/festivals";

export const Route = createFileRoute("/admin/_list-master/festivals")({
  component: Page,
});
